import { Routes, Route, Navigate } from 'react-router-dom'

import PileFormView from 'Presentation/Views/Pile/Form/View'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'
import PileListView from 'Presentation/Views/Pile/List/View'

const PileRoutes = () => (
  <Routes>
    <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.machine} />}>
      <Route path=':id' element={<PileFormView />} />

      <Route path='create' element={<PileFormView />} />

      <Route index element={<PileListView />} />

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default PileRoutes
